const NOTE_HTML_ALLOWED_IMAGE_TYPES = ['image/gif', 'image/jpeg', 'image/png', 'image/webp'] as const;

export default NOTE_HTML_ALLOWED_IMAGE_TYPES;
